var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backup",style:({ height: _vm.backUpHeight, width: _vm.backUpWidth, display: _vm.visible ? 'flex' : 'none', background: _vm.backBg })},[_c('a-spin',{attrs:{"tip":_vm.spinText,"size":"large"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }